import { CSSObject } from '@chakra-ui/react';

export const BoxPageWrapper: CSSObject = {
  px: '0',
};

export const BoxSectionWrapper: CSSObject = {
  mb: ['2', '3.5'],
  px: 0,

  _last: {
    a: {
      _last: { borderBottom: [0, 'unset'] },
    },
  },
};

export const BoxSportWrapper: CSSObject = {
  borderColor: 'transparent',
  borderRadius: 'base',
  border: 'none',
  bg: 'transparent',
  boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.15)',
};

export const TextTitle: CSSObject = {
  color: 'white',
  fontSize: 'xl',
  fontFamily: 'Staatliches',
  fontWeight: 'normal',
};

export const LinkItem: CSSObject = {
  color: 'white',
  bg: 'alpha.900',
  border: 'none',
  borderRadius: 'md',
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
  h: '36px',
  mb: ['1', '2'],
  _last: { mb: '0' },
  _hover: { bg: 'alpha.200' },
};

export const IconSport: CSSObject = {
  color: 'gamma.400',
  filter: 'drop-shadow(0px 3px 4px rgba(0, 0, 0, 0.25))',
};

export const IconChevron: CSSObject = {
  boxSize: '5',
  border: 'none',
  p: '1',
  color: 'white',
};

export const TextName: CSSObject = {
  fontFamily: 'Staatliches',
  fontSize: 'sm',
  fontWeight: 'normal',
};
